// extracted by mini-css-extract-plugin
export default {"checkbox":"BaseRadioItem_checkbox_O5ilx","choice":"BaseRadioItem_choice_Rgkxq","check":"BaseRadioItem_check_wUtW7","vertically_long":"BaseRadioItem_vertically_long_WMsUb"};